import React from 'react';
import { useSelector } from 'react-redux';
import styles from './_ticket-submission.module.scss';
import { IEmployee } from '../../Interfaces/Admin/IEmployee';
import { AppState } from '../../store/rootReducer';
import ComponentContainer from '../ComponentContainer/ComponentContainer';

const FIRST_NAME_SEARCH_VALUE = 'REPLACE_FIRST_NAME';
const LAST_NAME_SEARCH_VALUE = 'REPLACE_LAST_NAME';
const EMAIL_SEARCH_VALUE = 'REPLACE_EMAIL';
const REPLACE_PRODUCT_NAME = 'REPLACE_PRODUCT_NAME';

export default function TicketSubmission() {
  const employees = useSelector((state: AppState) => state.applications.employees);
  const activeUser: IEmployee = useSelector((state: AppState) => state.applications.loggedInUser!.employee);
  const currentEmployee = employees.find((e) => e.id === activeUser.id);

  // Get generic ticket submission url
  const helpDeskUrl = useSelector((state: AppState) => state.applications.lookups.helpDeskUrl);

  // Create unique url for the current user
  const ticketSubmissionUrl: string = helpDeskUrl 
    ? helpDeskUrl
      .replace(FIRST_NAME_SEARCH_VALUE, currentEmployee?.firstName ?? "")
      .replace(LAST_NAME_SEARCH_VALUE, currentEmployee?.lastName ?? "")
      .replace(EMAIL_SEARCH_VALUE, currentEmployee?.emailAddress ?? "")
      .replace(REPLACE_PRODUCT_NAME, "LOS")
     : '';
  
  return (
      <iframe
        style={{minHeight: '100vh', width: '100%', paddingBottom: '60px'}}
        src={ticketSubmissionUrl}
      ></iframe>
  );
}
